export enum PUSHER_STATES {
  UNAVAILABLE = "UNAVAILABLE",
}

export enum PUSHER_CHANNEL {
  PUBLIC_SYSTEM = "public-system",
  PRIVATE_SPACE_USER = "private-space_user_connection-",
  PRIVATE_SPACE = "private-space-",
  PRIVATE_USER = "private-user-",
  PRIVATE_ROOM = "private-room-",
}
